import React from 'react'

import CenteredContent from 'components/CenteredContent'

import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'

interface Props extends React.HTMLProps<HTMLDivElement> {
  fillHeight?: number
}

const styles = (theme: Theme) => createStyles({
  root: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    zIndex: theme.zIndex.appBar + 1,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const CenteredBottom: React.SFC<InjectedProps> = ({ classes, fillHeight, ...props }) => (
  <>
    {Boolean(fillHeight && fillHeight > 0) && <div style={{ height: fillHeight}} />}
    <div className={classes.root}>
      <CenteredContent {...props} />
    </div>
  </>
)

export default withStyles(styles)(CenteredBottom)
